import Link from '@mui/material/Link'
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
import { getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { table, viewId } from '../../../../_constants/Code'
import { errorLog } from '../../../../common/logger/Logger'
import React from 'react'
import { useSelector } from 'react-redux'
import CustomTooltip from '../../../../_components/CustomTooltip'
import { ReactComponent as UndoIcon } from '../../../../assets/icon/undo.svg'

const delimiter = '、'

export const useCertificationSetTableHeaders = (props) => {
  const { onEdit: handleEdit, onDelete: handleDelete, certifications = [] } = props

  return [
    {
      key: 'CertificationSetName',
      className: 'w-[20%] text-left ',
      label: '資格セット名',
      render(row, index) {
        const isDeleted = row.deleted
        const certificationSetName = row?.CertificationSetName

        return (
          <CustomTooltip title={certificationSetName}>
            {(ref) => (
              <Link
                ref={ref}
                className={
                  `text-sm w-full truncate !text-left` +
                  ` ${isDeleted ? '!line-through  !text-gray-900 !decoration-gray-900 ' : ' !no-underline'} `
                }
                component="button"
                disabled={isDeleted}
                onClick={() => !isDeleted && handleEdit(row, index)}
              >
                {certificationSetName}
              </Link>
            )}
          </CustomTooltip>
        )
      }
    },

    {
      key: 'CertificationCodeList',
      className: 'text-left truncate  ',
      label: '設定内容',
      render(row, index) {
        const isDeleted = row.deleted

        const list = row.CertificationCodeList.map((e) => certifications?.[e]?.CertificationData.Name)
          .filter(Boolean)
          .join(delimiter)

        return (
          <span className="inline-flex w-full px-3 justify-between  ">
            <CustomTooltip title={list}>
              {(ref) => (
                <span ref={ref} className={`${isDeleted && 'line-through'}  max-w-[95%] truncate`}>
                  {list}
                </span>
              )}
            </CustomTooltip>

            <DeleteButtonComponent isNodeDeleted={row.deleted} onRemoveNode={() => handleDelete(index)} />
          </span>
        )
      }
    }
  ]
}

const DeleteButtonComponent = ({ onRemoveNode, isNodeDeleted }) => {
  const beforeClasses = [
    'before:absolute',
    'before:block',
    "before:content-['']",
    'before:h-[30px]',
    'before:w-[30px]',
    'before:z-10',
    'before:rounded-full',
    'before:hidden',
    'before:bg-gray-600/10'
  ]
  const before = beforeClasses.join(' ')

  if (isNodeDeleted) {
    return (
      <IconButton
        data-testid="restore"
        size="small"
        className={`!p-0 relative !text-gray-600/50 ${before} hover:before:block  `}
        onClick={onRemoveNode}
      >
        <UndoIcon className="z-20 w-[20px] h-[20px]" />
      </IconButton>
    )
  }

  return (
    <IconButton
      data-testid="delete"
      size="small"
      className={`!p-0 relative !text-gray-600/50 ${before} hover:before:block  `}
      onClick={onRemoveNode}
    >
      <DeleteIcon className="z-20" fontSize="small" />
    </IconButton>
  )
}

export const useCertificationSetResources = () => {
  const corporationNumber = useSelector((state) => state.company.corporationNumber)
  const userId = useSelector((state) => state.user.sub)

  const getCertificationSets = async () => {
    try {
      const certificationSets = await getDynamoDB(table.CertificationSet, null, corporationNumber)

      if (!certificationSets) throw new Error('資格セットの取得に失敗しました')

      return certificationSets
    } catch (error) {
      console.error(error)
      return
    }
  }

  const getMaster = async () => {
    try {
      const master = await getDynamoDB(table.Master, null, corporationNumber, {
        CorporationNumber: corporationNumber,
        MasterId: viewId.certificationSet
      })
      return master[0]
    } catch (error) {
      console.error(error)
      errorLog('E000001', userId, viewId.certificationSet, 'getMaster', error)
    }
  }

  return { getMaster, getCertificationSets }
}
